class Sort
{
    constructor()
    {
        this.key = null;
        this.asc = true;
    }
    
    setKey(key)
    {
        if(this.key === key) this.asc = !this.asc;
        this.key = key;
        return this;
    }
    
    apply(powerplants)
    {
        switch(this.key) {
            case 'name':
                powerplants.sort((ppA, ppB) => ppA.getName().localeCompare(ppB.getName()));
                break;
            case 'power':
                powerplants.sort((ppA, ppB) => ppA.getTotalPower() - ppB.getTotalPower());
                break;
            case 'percentAuto':
                powerplants.sort((ppA, ppB) => ppA.getPercentAuto() - ppB.getPercentAuto());
                break;
            case 'nbTrackersManual':
                powerplants.sort((ppA, ppB) => ppA.getNbTrackersManual() - ppB.getNbTrackersManual());
                break;
            case 'nbTrackersError':
                powerplants.sort((ppA, ppB) => ppA.getNbTrackersError() - ppB.getNbTrackersError());
                break;
            case 'availability':
                powerplants.sort((ppA, ppB) => ppA.getLastDailyTrackerAvailability() - ppB.getLastDailyTrackerAvailability());
                break;
            default:
                break;
        }
        if(this.asc === false) {
            powerplants.reverse();
        }
    }
}

export default Sort;